module.exports = __webpack_public_path__ + "img/the_header.0ba1c632.png";